export function parseCurrency(valor) {
    if (!valor) return null;

    const valorStr = typeof valor === "string" ? valor : valor.toString();

    if (valorStr.includes(".") && valorStr.includes(",")) {
        valor = valorStr.replace("R$ ", "").replace(/\./g, "").replace(",", ".");
    } else if (valorStr.includes(",")) {
        valor = valorStr.replace("R$ ", "").replace(",", ".");
    } else {
        valor = valorStr.replace("R$ ", "");
    }

    return parseFloat(valor);
}
